import React, { useEffect, useRef, useState } from "react";
import { Container } from "../../../../DistributionComponents/common/Container";
import { GridCell } from "../../../../DistributionComponents/common/GridCell";
import { GridRow } from "../../../../DistributionComponents/common/GridRow";
import { Card } from "../../../../foundation/Card";
import { Message } from "../../../../foundation/Message/Message";
import logo from "../../../../assets/logo-icon.png";
import "./Form.css";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { MESSAGES } from "../../../../constants/constants";
import { SpinnerButton } from "../../../../foundation/Button";
import { Recaptcha } from "../../../../foundation/Recaptcha";


export const Form = (props) => {
  const {
    headerText,
    onSubmit,
    submitText,
    onFooterRender,
    isSpinning,
    onTos,
    onNewsLetter,
    verifyVisible,
    hasForgotPass,
    fingerprintId
  } = props;
  const [message, setMessage] = useState(props.message || {});
  const [renderGoogle] = useState(true);
  const formDataRef = useRef({});
  const inputRef = useRef(null);
  useEffect(() => {
    setMessage(props.message);
  }, [props.message]);

  const renderFooter = () => {
    if (onFooterRender) {
      return onFooterRender();
    } else {
      return (
        <div>
          <div className="xs-regular">
            <span>Have an account? </span>
            <a className="font-medium text-blue-600  hover:underline" href="/login">Sign in</a>
          </div>
        </div>
      );
    }
  };
  const handleSubmit = (e, token) => {
    const formData = new FormData(formDataRef.current);
    formData.append("token", token);
    const formDataObj = Object.fromEntries(formData.entries());
    onSubmit(formDataObj);
  };
  const handleCodeInput = () => {
    const input = inputRef.current.value;
    inputRef.current.value = input.replace(/[^0-9]/g, "");
  };  
  const rederGoogleLogin = () => {
    return (
      <div>
        <div className="dp-f-jc mgt-8">
          <GoogleOAuthProvider clientId="481964866925-66rcsqb3rsk92o2mhqbjog7oags72h8q.apps.googleusercontent.com">
            <GoogleLogin
              onSuccess={async (credentialResponse) => {
                try {
                  const response = await fetch("/api/googlelogin", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({...credentialResponse,fingerprintId}),
                    redirect: "follow", // Follow redirects
                  });
                  const text = await response.text(); // Parse it as text
                  const data = JSON.parse(text); // Try to parse it as JSON
                  if (data?.success) {
                    if (onNewsLetter) {
                      window.clarity("event", "Signup Completed");
                    }
                    props.trackEvent(
                      onNewsLetter ? "Signup Completed" : "Login Completed",
                      {
                        flow: onNewsLetter ? "Sign up" : "Login Page",
                        type: "Google",
                      }
                    );
                    // Redirect to the dashboard page
                    window.location.href = data.url;
                  } else {
                    setMessage({ type: MESSAGES.ERROR, text: data.message });
                  }
                } catch (err) {
                  setMessage({
                    type: MESSAGES.ERROR,
                    text: "Some unknown error occured",
                  });
                  // The response wasn't a JSON object
                  // Do your text handling here
                }
                // setGoogleCred(credentialResponse)
              }}
              onError={() => {
                console.log("Login Failed");
              }}
            />
          </GoogleOAuthProvider>
        </div>
      </div>
    );
  };
  return (
    <div>
      <Container>
        <GridRow>
          <GridCell desktop={6} mobile={12}>
            <form ref={formDataRef} id="main-form" onSubmit={onSubmit}>
              <Card className="form-container form-card">
                <Message message={message} />
                <div className="login-logo">
                  <img src={logo} width="64" />
                </div>
                <div className="mgb-16 xl-bold">{headerText}</div>
                <input
                  onChange={() => setMessage({})}
                  className="mgb-12"
                  required
                  type={"email"}
                  placeholder={"Email"}
                  name="email"
                />
                <input
                  onChange={() => setMessage({})}
                  className="mgb-12"
                  minLength={8}
                  required
                  type={"password"}
                  placeholder={"Password"}
                  name="password"
                />
                {verifyVisible && (
                  <input
                    ref={inputRef}
                    id="verficationCode"
                    onChange={() => setMessage({})}
                    onInput={handleCodeInput}
                    className="mgb-12"
                    required
                    type="text"
                    placeholder={"Verification Code"}
                    name="code"
                  />
                )}
               {hasForgotPass && <a
                  href="/forgotPassword"
                  className="text-sm text-blue-600  hover:underline"
                >
                  forgot Password?
                </a>}
                {onNewsLetter && onNewsLetter()}
                <div className="form-spinner-btn">
                  <Recaptcha>
                    <SpinnerButton
                      isSpinning={isSpinning}
                      text={submitText}
                      data-analytics={submitText + "click"}
                      data-analytics-name={submitText}
                      onClick={handleSubmit}
                    />
                  </Recaptcha>
                </div>

                {renderFooter()}
                {renderGoogle && rederGoogleLogin()}
                {onTos && onTos()}
              </Card>
            </form>
          </GridCell>
        </GridRow>
      </Container>
    </div>
  );
};
